import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

//components
import ManageTableWithDynamicPagination from "../../Components/TableTemplate/ManageTableWithDynamicPagination";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";
import {
    createBank,
    deleteBanks,
    getAllBanks,
    searchBank,
    updateBank,
} from "../../Helpers/apiCalls/Manage/Banks";
import { getAllCheckTemplates } from "../../Helpers/apiCalls/Manage/CheckTemplates";
import toast from "react-hot-toast";
import { toastStyle, refreshPage, isAdmin } from "../../Helpers/Utils/Common";
import { validateBanks } from "../../Helpers/Validation/Manage/BanksValidation";
import InputError from "../../Components/InputError/InputError";
import Footer from "../../Components/Footer/Footer";
import downloadIcon from "../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

export default function Banks() {
    const [inactive, setInactive] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [option, setOption] = useState("Select");
    const [isClicked, setIsClicked] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
        page: 1,
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    // MODALS //
    // DELETE
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // VIEW
    const [showViewBankModal, setShowViewBankModal] = useState(false);
    const handleShowViewBankModal = () => setShowViewBankModal(true);
    const handleCloseViewBankModal = () => setShowViewBankModal(false);

    // EDIT
    const [showEditBankModal, setShowEditBankModal] = useState(false);
    const handleShowEditBankModal = () => setShowEditBankModal(true);
    const handleCloseEditBankModal = () => setShowEditBankModal(false);

    // ADD
    const [showAddBankModal, setShowAddBankModal] = useState(false);
    const handleShowAddBankModal = () => setShowAddBankModal(true);
    const handleCloseAddBankModal = () => setShowAddBankModal(false);

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        bank_name: false,
        account_name: false,
        account_no: false,
    });

    //API
    const [banksData, setBanksData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [checkTemplateData, setCheckTemplateData] = useState([]);
    const [searchBankName, setSearchBankName] = useState("");
    const [addBankData, setAddBankData] = useState({
        bank_name: "",
        account_name: "",
        account_no: "",
    });
    const [editBankData, setEditBankData] = useState({
        bank_id: "",
        bank_name: "",
        account_name: "",
        account_no: "",
    });

    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setAddBankData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditBankData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const xlsxHeaders =  [
        "BANK NAME",
        "ACCOUNT NAME",
        "ACCOUNT NO."
    ]

    //EXPORT 
    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "Banks.xlsx", { compression: true });
    }

    //DROPDOWN
    function handleSelectChange(e, row) {
        
        setSelectedRow(row);

        if (e.target.value === "delete-bank") {
            handleShowDeleteModal();
        } else if (e.target.value === "edit-bank") {
            setEditBankData(row);
            handleShowEditBankModal();
        } else if (e.target.value === "view-enrollment") {
            handleShowViewBankModal();
        } else {
            handleShowDeleteModal();
        }
        setShowLoader(false);
    }

    function ActionBtn(row) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action form-select"
                id={row.id}
                onChange={(e) => handleSelectChange(e, row)}
                value={option}
            >
                <option defaulValue selected hidden>
                    Select
                </option>
                {isAdmin() && (
                    <option value="edit-bank" className="color-options">
                        Edit
                    </option>
                )}
                {isAdmin() && (
                    <option value="delete-bank" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }
    
    async function create() {
        if (validateBanks(addBankData, setIsError)) {
            setIsClicked(true);
            const response = await createBank(addBankData);
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
            setIsClicked(false);
        }
    }

    async function searchBanks() {
        setTotalItems(0);
        setBanksData([]);
        setShowLoader(true);
        filterConfig.name = searchBankName
        const response = await searchBank(filterConfig);
        if (response.data) {
            let result = response.data.data.data.map((a) => {
                return {
                    id: a.id,
                    bank_name: a.bank_name,
                    account_name: a.account_name,
                    account_no: a.account_no,
                    action_btn: ActionBtn(a),
                };
            });
            setBanksData(result);
            setTotalItems(response.data.data.size)

            var excel = result.map((data) => {
                var info = {};
                info.bank_name = data.bank_name
                info.account_name = data.account_name
                info.account_no = data.account_no
                return info;
            });
            setExcelData(excel)
        }
        setShowLoader(false);
    }

    async function del() {
        setIsClicked(true);
        const response = await deleteBanks(selectedRow.id);
        
        if (response.data) {
            toast.success(response.data.message, {
                style: toastStyle(),
            });
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
        }
        setTimeout(() => refreshPage(), 1000);
    }

    async function editBank() {
        if (validateBanks(editBankData, setIsError)) {
            const response = await updateBank(editBankData);
            setIsClicked(true);

            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setShowEditBankModal(false);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
            setTimeout(() => refreshPage(), 1000);
        }
    }

    useEffect(() => {
        searchBanks();
    }, [searchBankName, filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"MANAGE"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> BANKS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            className="search-bar"
                            defaultValue=""
                            name="search"
                            placeholder="Search name..."
                            // onChange={(e) => setSearchBankName(e.target.value)}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                setSearchBankName(e.target.value)
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                            <button
                                className="add-btn"
                                onClick={handleShowAddBankModal}
                            >
                                Add
                            </button>
                        </div>
                    </Col>
                </Row>

                {/* TABLE */}
                <div className="tab-content">
                    <ManageTableWithDynamicPagination
                        tableHeaders={[
                            "BANK NAME",
                            "ACCOUNT NAME",
                            "ACCOUNT NO.",
                            "ACTIONS",
                        ]}
                        headerSelector={[
                            "bank_name",
                            "account_name",
                            "account_no",
                        ]}
                        tableData={banksData}
                        ActionBtn={(row) => ActionBtn(row)}
                        showLoader={showLoader}
                        // withActionData={true}
                        // used in dynamic pagination
                        totalItems={totalItems}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        handlePageChange={handlePageChange}
                    />
                </div>
                <div className="mb-3" />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>

            {/* MODALS */}
            <DeleteModal
                text="bank"
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onDelete={() => del()}
                isClicked={isClicked}
            />
            <AddModal
                title="BANK"
                size="lg"
                type="bank"
                show={showAddBankModal}
                onHide={handleCloseAddBankModal}
                onSave={() => create()}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col>
                            BANK NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="bank_name"
                                value={addBankData.bank_name}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.bank_name}
                                message={"Bank name is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-2">
                        <Col>
                            ACCOUNT NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="account_name"
                                value={addBankData.account_name}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.account_name}
                                message={"Account Name is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-2">
                        <Col>
                            ACCOUNT NUMBER
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="account_no"
                                value={addBankData.account_no}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.account_no}
                                message={"Account number is required"}
                            />
                        </Col>
                    </Row>
                </div>
            </AddModal>
            <EditModal
                title="BANK"
                size="lg"
                type="bank"
                show={showEditBankModal}
                onHide={handleCloseEditBankModal}
                onSave={editBank}
                isClicked={isClicked}
            >
                <div className="mt-3">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col>
                            BANK NAME
                            <Form.Control
                                type="text"
                                name="bank_name"
                                value={editBankData.bank_name}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.bank_name}
                                message={"Bank name is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-2">
                        <Col>
                            ACCOUNT NAME
                            <Form.Control
                                type="text"
                                name="account_name"
                                value={editBankData.account_name}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.account_name}
                                message={"Account name is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-2">
                        <Col>
                            ACCOUNT NUMBER
                            <Form.Control
                                type="text"
                                name="account_no"
                                value={editBankData.account_no}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.account_no}
                                message={"Account number is required"}
                            />
                        </Col>
                    </Row>
                </div>
            </EditModal>
            <ViewModal
                show={showViewBankModal}
                onHide={handleCloseViewBankModal}
                onSave={() => alert("Save")}
            >
                <div>
                    <div className="col-sm-12 space">
                        <span className="custom-modal-body-title">
                            CHECK ENROLLMENT
                        </span>
                    </div>
                    <div className="edit-form mt-3 mb-3">
                        <div className="mt-0 mb-0">
                            <Row className="nc-modal-custom-row mt-0 mb-3">
                                <Col>
                                    FROM
                                    <Row className="nc-modal-custom-row">
                                        <Col>
                                            {" "}
                                            <Form.Control
                                                type="text"
                                                name="from"
                                                className="nc-modal-custom-input"
                                                required
                                            />{" "}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    TO
                                    <Row className="nc-modal-custom-row">
                                        <Col>
                                            {" "}
                                            <Form.Control
                                                type="text"
                                                name="from"
                                                className="nc-modal-custom-input"
                                                required
                                            />{" "}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>

                        <div className="col-sm-12 d-flex justify-content-end mb-3 ">
                            <button
                                className="button-tertiary "
                                onClick={() => handleCloseViewBankModal(true)}
                            >
                                Cancel
                            </button>
                            <button
                                className="mx-3 button-primary "
                                onClick={() => handleCloseViewBankModal(true)}
                            >
                                Save
                            </button>
                        </div>
                        <Row className="m-divider mb-3"></Row>
                        <div className="col-sm-12 space"></div>
                        <div className="col-sm-12 space">
                            <div className="m-0 mb-0">
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        ENROLLED CHECKS
                                        <Row className="nc-modal-custom-row-box">
                                            <Col className="nc-modal-custom-row-grey">
                                                {" "}
                                                FROM{" "}
                                            </Col>

                                            <Col className="nc-modal-custom-row-grey">
                                                {" "}
                                                TO{" "}
                                            </Col>
                                            <Col className="nc-modal-custom-row-grey">
                                                {" "}
                                                REMAINING CHECKS{" "}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </ViewModal>
            <Footer/>
        </div>
    );
}
